var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"card-view"},[_c('h2',[_vm._v(_vm._s(((_vm.user.first_name) + "'s " + (_vm.$t('text.cards')))))]),_c('add-card')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }